"use strict";
/**
 * Created by Pankaj on 2019-12-20.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoPanelEvents = void 0;
class PromoPanelEvents {
}
//generic evnets
PromoPanelEvents.BALANCE_UPDATE_EVENT = "onBalanceUpdate";
PromoPanelEvents.ON_RESIZE = "promoPanelOnResize";
PromoPanelEvents.ON_ORIENTATION_CHANGED = "promoPanelOnOrientationChanged";
//Nav Button Panel events
PromoPanelEvents.NAV_BUTTON_PRESSED = "onNavButtonPressed";
PromoPanelEvents.DISABLE_ALL_NAV_BUTTON = "disableAllNavButtons";
PromoPanelEvents.DISABLE_NAV_BUTTON = "disableNavButtons";
PromoPanelEvents.ENABLE_NAV_BUTTON = "enableNavButtons";
PromoPanelEvents.HIDE_NAV_BUTTON = "hideNavButtons";
PromoPanelEvents.SHOW_NAV_BUTTON = "showNavButtons";
//Bet Panel Events
PromoPanelEvents.ON_BET_CHANGE = "onBetChange";
PromoPanelEvents.DISABLE_BET_BUTTONS = "disableBetButtons";
PromoPanelEvents.ENABLE_BET_BUTTONS = "enableBetButtons";
//PopUp View Events
PromoPanelEvents.ON_POPUP_OPEN = "onPopUpOpen";
PromoPanelEvents.ON_POPUP_CLOSE = "onPopUpClose";
//Lightning Spins
PromoPanelEvents.TOGGLE_BUTTONS_ON_LIGHTING_SPINS = "toggleButtonOnLightningSpins";
PromoPanelEvents.AS_REPLAY_ADD_BLUR = "actionSpinReplayAddBlur";
PromoPanelEvents.AS_REPLAY_REMOVE_BLUR = "actionSpinReplayRemoveBlur";
PromoPanelEvents.ACTION_SPIN_DATA = "actionSpinData";
PromoPanelEvents.SHOW_HIDE_CLOSE_BUTTON = "showHideCloseBtn";
PromoPanelEvents.BLUR_BACKGROUND = "blurBackground";
PromoPanelEvents.PROMO_PANEL_OPENED = "promoPanelOpened";
PromoPanelEvents.PROMO_PANEL_CLOSED = "promoPanelClosed";
PromoPanelEvents.PROMO_PANEL_MINIMIZED = "promoPanelMinimized";
PromoPanelEvents.PROMO_PANEL_MAXIMIZED = "promoPanelMaximized";
PromoPanelEvents.DIALOG_SHOWN = "dialogShown";
//FreeBet Events
PromoPanelEvents.FREE_BETS_START = "freeBetsStart";
PromoPanelEvents.FREE_BETS_END = "freeBetsEnd";
exports.PromoPanelEvents = PromoPanelEvents;
//# sourceMappingURL=PromoPanelEvents.js.map